import { Box, InputLabel, TextField, Tooltip } from "@mui/material";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import { Col, Row } from "react-bootstrap";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import ExcelIcon from "../../assets/images/ExcelExport.png";
import { useEffect, useRef, useState } from "react";
import styles from "./PendingMessages.module.css";
import { ColDef } from "ag-grid-enterprise";
import { useLoader } from "../../context/LoaderContext";
import { appSettings } from "../../config/appSetting";
import { useSnackbar } from "../Common/SnackbarContext";
import { AgGridReact } from "ag-grid-react";
import CustomLoadingOverlay from "../CustomLoadingOverlay/CustomLoadingOverlay ";
import {
  getDQDeptCount,
  getPendingMessageData,
} from "../../api/pendingMessageApi/pendingMessageApi";
import { FormatDate } from "../Common/CommonMethods";

const PendingMessages = () => {
  const [searchValue, setSearchValue] = useState("");
  const [resetShow, setResetShow] = useState(false);
  const [gridRecordExist, setGridRecordExist] = useState(false);
  const { setLoading } = useLoader();
  const pageSizeSelector = appSettings.agGridPageSizeSelector;
  const defaulPageSize = 5000;
  const { showSnackbar } = useSnackbar();
  const gridRef = useRef<AgGridReact>(null);
  const [rowData, setRowData] = useState<any[]>([]);
  const [dqDeptCount, setDQDeptCount] = useState<number>(0);

  useEffect(() => {
    const params = {
      SearchTerm: searchValue,
    };
    getData(params);
  }, []);

  const getDQdeptCount = async () => {
    try {
      const response = await getDQDeptCount();
      setDQDeptCount(response);
    } catch (error) {
      console.log("failed to load", error);
    }
  };

  const getData = async (params: any) => {
    setLoading(true);
    try {
      const pendingMessageData = await getPendingMessageData(params);
      setRowData(pendingMessageData);
      if (pendingMessageData.length > 0) {
        setGridRecordExist(true);
      } else {
        setGridRecordExist(false);
        setRowData([]);
        showSnackbar("0 records found");
      }
    } catch (error) {
      console.error("Error fetching pending messages", error);
    } finally {
      setLoading(false);
      getDQdeptCount();
    }
  };

  const [columnDef] = useState<ColDef[]>([
    {
      headerName: "#",
      width: 100,
      sortable: false,
      filter: false,
      resizable: false,
      colId: "col1",
      valueGetter: (params) => {
        return params.node ? (params.node.rowIndex ?? 0) + 1 : 0;
      },
      cellStyle: () => {
        return { borderright: "1px solid #dee2e6" };
      },
    },
    {
      headerName: "QPosition",
      field: "QPosition",
      width: 150,
      hide: false,
      colId: "col2",
      enableRowGroup: true,
      filter: true,
    },
    {
      headerName: "Elapsed Time",
      field: "ElapsedTime",
      width: 240,
      hide: false,
      colId: "col3",
      enableRowGroup: true,
      filter: true,
    },
    {
      headerName: "Enqueued Time",
      field: "EnqueueTime",
      width: 240,
      hide: false,
      colId: "col4",
      enableRowGroup: true,
      filter: true,
      valueFormatter: (params: any) => {
        return FormatDate(params.value);
      },
    },
    {
      headerName: "Document",
      field: "DocumentId",
      width: 300,
      hide: false,
      colId: "col5",
      enableRowGroup: true,
      filter: true,
    },
    {
      headerName: "CUSIP",
      field: "Cusip",
      width: 320,
      hide: false,
      colId: "col6",
      enableRowGroup: true,
      cellDataType: "string",
      filter: true,
      valueFormatter: (params: any) => {
        if (params.value === null || params.value === undefined) return "";
        return params.value.toString();
      },
    },
    {
      headerName: "Fund Name",
      field: "FundName",
      width: 200,
      hide: false,
      colId: "col7",
      enableRowGroup: true,
      filter: true,
    },
    {
      headerName: "Message",
      field: "Message",
      width: 400,
      hide: false,
      colId: "col8",
      enableRowGroup: true,
      filter: true,
      valueFormatter: (params) =>
        typeof params.value === "object" && params.value !== null
          ? JSON.stringify(params.value)
          : params.value,
    },
  ]);

  const handleInputChange = (event: any) => {
    setSearchValue(event.target.value);
    setResetShow(true);
  };

  const handleSearchKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      const params = {
        SearchTerm: searchValue,
      };
      getData(params);
    }
  };

  const handleSearch = () => {
    const params = {
      SearchTerm: searchValue,
    };
    getData(params);
  };

  const handleReset = () => {
    setSearchValue("");
    setResetShow(false);
    setRowData([]);
    const params = {
      SearchTerm: "",
    };
    getData(params);
  };

  // Export data to excel
  const handleExport = () => {
    if (gridRef.current) {
      gridRef.current.api.exportDataAsExcel({
        fileName: "PendingMessages.xlsx",
        sheetName: "Pending Messages",
      });
      showSnackbar("File successfully downloaded.");
    }
  };

  return (
    <div>
      <NavigationBar
        menuTitle="Queue Management"
        screenTitle=""
        title="Pending Messages"
        text="Pending Messages"
      />
      <Row style={{ margin: "1em" }}>
        <Col xs={12}>
          <Box>
            {/* Search Input box */}
            <div>
              <Box
                component="form"
                sx={{ "& .MuiTextField-root": { m: 1, width: "50ch" } }}
                noValidate
                autoComplete="off"
                style={{
                  marginTop: "-1.5em",
                }}
              >
                <TextField
                  id="txtElasticSearch"
                  variant="outlined"
                  fullWidth
                  style={{
                    padding: "0px",
                    margin: "0px",
                    display: "none",
                  }}
                  value={searchValue}
                  onChange={handleInputChange}
                  onKeyDown={handleSearchKeyPress}
                  InputProps={{
                    style: { backgroundColor: "white", height: "35px" },
                  }}
                ></TextField>
                <input
                  type="text"
                  id="filter-text-box"
                  value={searchValue}
                  className={styles.txtSearch}
                  onInput={handleInputChange}
                  onKeyDown={handleSearchKeyPress}
                />
                <Tooltip title="Please click to search">
                  <SearchIcon
                    onClick={handleSearch}
                    style={{
                      margin: ".65em 0em 1em .1em",
                      color: "var(--text-color)",
                      height: "1em",
                      width: "1em",
                    }}
                  />
                </Tooltip>
                {resetShow && (
                  <Tooltip title="Please click to Reset">
                    <ClearIcon
                      onClick={handleReset}
                      style={{
                        margin: ".7em 0em 1em .1em",
                        color: "var(--text-color)",
                        height: "1em",
                        width: "1em",
                      }}
                    />
                  </Tooltip>
                )}

                <div
                  className="d-flex"
                  style={{
                    float: "right",
                    marginRight: "20px",
                    marginTop: "0.5em",
                  }}
                >
                  <InputLabel
                    style={{
                      color: "var(--text-color)",
                      fontWeight: 600,
                      fontSize: "16px",
                      marginBottom: "-0.5em",
                      marginTop: "0.5em",
                      marginRight: "1em",
                      width: "55px",
                      height: "55px",
                      borderRadius: "50%",
                      background:
                        dqDeptCount > appSettings.pendingMessagesCriticalCount
                          ? "Lightcoral"
                          : "lightgreen", // Light Red if > 100, else Light Green
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                    }}
                  >
                    {dqDeptCount}
                  </InputLabel>
                  {gridRecordExist && (
                    <Tooltip title="Click to export the grid content in excel">
                      <button
                        type="button"
                        onClick={handleExport}
                        style={{
                          background: "none",
                          border: "none",
                          padding: 0,
                          cursor: "pointer",
                          marginTop: "0.5em",
                          marginRight: "-1.5em",
                        }}
                        aria-label="Export to Excel"
                      >
                        <img
                          src={ExcelIcon}
                          alt="Doc-Distro"
                          className="excel-icon"
                          style={{ width: 32, height: 32 }}
                        />
                      </button>
                    </Tooltip>
                  )}
                </div>
              </Box>
            </div>

            {/* Ag-Grid */}
            <div
              className="ag-theme-quartz-dark"
              style={{ height: "73vh", width: "100%", marginTop: "1em" }}
            >
              <AgGridReact
                rowData={rowData}
                columnDefs={columnDef}
                pagination={true}
                paginationPageSize={defaulPageSize}
                paginationPageSizeSelector={pageSizeSelector}
                rowGroupPanelShow="always"
                pivotPanelShow="always"
                ref={gridRef}
                headerHeight={30}
                loading={!rowData}
                loadingOverlayComponent={CustomLoadingOverlay}
                sideBar={{ toolPanels: ["columns", "filters"] }}
                overlayNoRowsTemplate={
                  '<span class="ag-overlay-loading-center">No rows to show</span>'
                }
                excelStyles={[
                  {
                    id: "header",
                    interior: {
                      color: "#e3f2fd",
                      pattern: "Solid",
                    },
                    font: {
                      bold: true,
                      color: "#144979",
                    },
                    alignment: {
                      horizontal: "Left",
                    },
                  },
                ]}
              />
            </div>
          </Box>
        </Col>
      </Row>
    </div>
  );
};
export default PendingMessages;
